<template>
	<div style="height: 100%">
		<!-- 景区内容区开始 -->
		<el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 10px">
			<el-breadcrumb-item>景区</el-breadcrumb-item>
		</el-breadcrumb>
		<el-card class="scroll" style="
                height: 100%;
                margin: 0 0 10px 0;
                overflow-y: scroll;
                box-sizing: content-box;
            " id="ceshi">
			<el-input size="mini"
					  style="width: 240px"
					  v-on:input="findScenic(1)"
					  placeholder="请输入景区"
					  clearable
					  v-model="scenicInfo"></el-input>
			<el-button size="mini"
					   @click="(dialogVisibleAddScenic = true),(dolxInfo = '1'),(areaID = '')" type="success">新增景区
			</el-button>
			<hr/>
			<el-row :gutter="30">
				<el-col v-for="feng in scenicList" :key="'area' + feng.area_id"
						:xs="8" :sm="6" :md="12" :lg="8" :xl="6" style="margin-bottom: 30px">
					<div style="
                            border: 1px solid #eee;
                            border-color: #bbb;
                            box-shadow: 2px 2px 2px #ddd;
                            padding: 1px 1px 10px 1px;
                        ">
						<img @click="routerScenicSpot(feng)" @contextmenu.prevent="
                                (dialogVisible = true),(dialogImageUrl = feng.area_pic) "
							 :src="feng.area_pic" style="
                                width: 100%;
                                min-height: 210px;
                                max-height: 210px;
                            "/>
						<ul>
							<li class="scenicName">{{ feng.area_name }}</li>
							<li style="color: #ff6913;font-size: 26px; margin: 10px 10px 0 10px;">
								<div>
									<el-switch style="min-width: 120px"
											   v-model="feng.is_view"
											   @change="updateShowHidden(feng)"
											   active-color="#13ce66"
											   active-text="显示"
											   inactive-text="隐藏"
											   inactive-color="#ff4949"
											   active-value="1"
											   inactive-value="0">
									</el-switch>
								</div>
								<div class="btns">
									<el-button type="primary" @click="showDivideEditer(feng)" size="mini">分成</el-button>
									<el-button type="primary" @click="statistics(feng)" size="mini">统计</el-button>
									<el-button type="warning" @click="updateScenic(feng)" size="mini">修改</el-button>
									<el-button type="info" @click="scenicDelete(feng)" size="mini">删除</el-button>
									<el-button type="primary" @click="qrCodeDialog(feng)" size="mini">小程序码</el-button>
								</div>
							</li>
						</ul>
					</div>
				</el-col>
			</el-row>
			<!-- 分页区 -->
			<el-pagination background
						   @size-change="handleSizeChange"
						   @current-change="handleCurrentChange"
						   :current-page="currentPage"
						   :page-sizes="[10, 20, 30, 40]"
						   :page-size="pageSize"
						   layout="total,  prev, pager, next, jumper"
						   :total="total"
						   style="
                    text-align: right;
                    margin: 0 16px 10px 0;
                    border-radius: 20px;
                ">
			</el-pagination>
		</el-card>

		<!-- 景区内容区结束 -->
		<!-- 新增修改景区弹出框开始 -->
		<el-dialog
				title="景区设置"
				:visible.sync="dialogVisibleAddScenic"
				:close-on-press-escape="false"
				:close-on-click-modal="false"
				@close="dialogVisibleAddScenicClose('ruleForm')"
				width="700px">
			<el-form
					:model="ruleForm"
					:rules="rules"
					ref="ruleForm"
					label-width="120px"
					class="demo-ruleForm">
				<el-form-item label="景区名称" prop="name">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="景区评级" prop="grade" :show-message="false">
					<el-rate
							text-color="#9999FF"
							show-text
							:texts="texts"
							v-model="ruleForm.grade"
							style="margin: 10px 0 0 0"
					></el-rate>
					<el-button type="primary" @click="ruleForm.grade = 0" size="mini">清零</el-button>
				</el-form-item>
				<el-form-item label="景区显示隐藏" prop="grade" :show-message="false">
					<el-switch
							v-model="ruleForm.showHidden"
							active-color="#13ce66"
							active-text="显示"
							inactive-text="隐藏"
							inactive-color="#ff4949"
							active-value="1"
							inactive-value="0">
					</el-switch>
				</el-form-item>
				<el-form-item label="景区图片" prop="scenicPhoto" :show-message="false">
					<el-upload style="width: 100%"
							   class="avatar-uploader" action="string"
							   :http-request="submitUploadScenicPhoto" :show-file-list="false">
						<img @contextmenu.prevent=" (dialogVisible = true), (dialogImageUrl = ruleForm.scenicPhoto)"
							 v-if="ruleForm.scenicPhoto" :src="ruleForm.scenicPhoto" class="avatar"
							 style="
                                width: 120px;
                                height: 120px;
                                border: 1px solid #e8e8e8;
                            "/>
						<i v-else class="el-icon-plus avatar-uploader-icon" style="
                                line-height: 120px;
                                width: 120px;
                                height: 120px;
                                border: 1px solid #e8e8e8;
                                vertical-align: middle;
                            "></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="文字简介" prop="synopsis">
					<el-input v-model="ruleForm.synopsis"></el-input>
				</el-form-item>
				<el-form-item label="语音简介" prop="fileList" :show-message="false">
					<el-upload
							class="upload-demo"
							:http-request="submit"
							:on-preview="handlePreview"
							:on-remove="handleRemove"
							:before-remove="beforeRemove"
							v-loading="loading"
							element-loading-spinner="el-icon-loading"
							element-loading-background="rgba(0, 0, 0, 0.8)"
							multiple
							:limit="1"
							action="string"
							:file-list="ruleForm.fileList">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item label="语音价格" prop="voicePrice">
					<el-input v-model="ruleForm.voicePrice"></el-input>
				</el-form-item>
				<el-form-item label="浏览量" prop="pageView">
					<el-input v-model="ruleForm.pageView"></el-input>
				</el-form-item>
				<el-form-item label="景区地图" prop="map" :show-message="false">
					<el-upload
							style="width: 100%"
							class="avatar-uploader"
							action="string"
							:http-request="submitUploadScenicMap"
							:show-file-list="false">
						<img
								@contextmenu.prevent="
                                (dialogVisible = true),
                                    (dialogImageUrl = ruleForm.scenicMap)
                            " v-if="ruleForm.scenicMap"
								:src="ruleForm.scenicMap"
								class="avatar"
								style="
                                width: 120px;
                                height: 120px;
                                border: 1px solid #e8e8e8;
                            "/>
						<i v-else class="el-icon-plus avatar-uploader-icon" style="
                                line-height: 120px;
                                width: 120px;
                                height: 120px;
                                border: 1px solid #e8e8e8;
                                vertical-align: middle;
                            "></i>
					</el-upload>
					<el-button type="primary" @click="ruleForm.scenicMap = ''"
							   v-if="ruleForm.scenicMap != ''" size="mini">删除
					</el-button>
				</el-form-item>
				<el-form-item label="景区缩放">
					<el-tooltip class="item" effect="dark" content="最小值 3,最大值 18" placement="top">
						<el-input-number v-model="ruleForm.level"
										 controls-position="right"
										 :min="3"
										 :max="18"></el-input-number>
					</el-tooltip>
				</el-form-item>

				<el-form-item label="景区左下　（经、纬）">
					<el-col :span="11">
						<el-form-item prop="leftLongitude">
							<el-input
									v-model="ruleForm.leftLongitude"
									placeholder="请输入经度"
									oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"
							></el-input>
						</el-form-item>
					</el-col>
					<el-col class="line" :span="2" style="text-align: center">-</el-col>
					<el-col :span="11">
						<el-form-item prop="leftLatitude">
							<el-input
									v-model="ruleForm.leftLatitude"
									placeholder="请输入纬度"
									oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"
							></el-input>
						</el-form-item>
					</el-col>
				</el-form-item>
				<el-form-item label="景区右上　（经、纬）">
					<el-col :span="11">
						<el-form-item>
							<el-input
									v-model="ruleForm.rightLongitude"
									placeholder="请输入经度"
									oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"></el-input>
						</el-form-item>
					</el-col>
					<el-col class="line" :span="2" style="text-align: center">-</el-col>
					<el-col :span="11">
						<el-form-item>
							<el-input v-model="ruleForm.rightLatitude"
									  placeholder="请输入纬度"
									  oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"></el-input>
						</el-form-item>
					</el-col>
				</el-form-item>
				<el-form-item label="景区经度" prop="longitude">
					<el-input v-model="ruleForm.longitude"
							  oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"></el-input>
				</el-form-item>
				<el-form-item label="景区纬度" prop="latitude">
					<el-input v-model="ruleForm.latitude"
							  oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"></el-input>
				</el-form-item>
				<el-form-item label="所在地区" prop="area">
					<el-input v-model="ruleForm.area" placeholder="如：山东省、潍坊市"></el-input>
				</el-form-item>
				<el-form-item label="详细地址" prop="detailedAddress">
					<el-input v-model="ruleForm.detailedAddress"></el-input>
				</el-form-item>
				<el-form-item label="是否需要门票" prop="is_selling_tickets">
					<el-radio-group v-model="ruleForm.is_selling_tickets">
						<el-radio label="1">是</el-radio>
						<el-radio label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-show="ruleForm.is_selling_tickets == 1" label="门票小程序appid" prop="ticket_app_id">
					<el-input v-model="ruleForm.ticket_app_id"></el-input>
				</el-form-item>
				<el-form-item v-show="ruleForm.is_selling_tickets == 1" label="门票购买链接" prop="ticket_url">
					<el-input v-model="ruleForm.ticket_url"></el-input>
				</el-form-item>
				<el-form-item label="营业时间" prop="businessHours">
					<el-input v-model="ruleForm.businessHours"></el-input>
				</el-form-item>
				<el-form-item label="门票" prop="ticket">
					<el-input v-model="ruleForm.ticket"></el-input>
				</el-form-item>
				<el-form-item label="建议游玩时间" prop="playTime">
					<el-input v-model="ruleForm.playTime"></el-input>
				</el-form-item>
				<el-form-item label="交通方式" prop="meansOfTransportation">
					<el-input v-model="ruleForm.meansOfTransportation"></el-input>
				</el-form-item>
				<el-form-item label="小贴士" prop="tips">
					<el-input v-model="ruleForm.tips"></el-input>
				</el-form-item>
				<el-form-item label="推荐路线" prop="recommendedRoute">
					<el-select v-model="ruleForm.recommendedRoute"
							   multiple
							   placeholder="请选择"
							   style="width: 100%">
						<el-option v-for="item in scenicSpotList"
								   :key="item.spot_id"
								   :label="item.spot_name"
								   :value="item.spot_id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="优惠券显示" prop="recommendedRoute">
					<el-radio-group v-model="ruleForm.coupon_view_flag">
						<el-radio label="1">是</el-radio>
						<el-radio label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitAddScenic('ruleForm')">保存</el-button>
					<el-button @click="dialogVisibleAddScenic = false">关闭</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 新增景区弹出框结束 -->
		<!-- 弹出框内图片查看大图开始 -->
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt=""/>
		</el-dialog>
		<!-- 弹出框内图片查看大图结束 -->
		<!-- 景区分成设置弹出框开始 -->
		<el-dialog title="景区分成设置" :visible.sync="divideDialogVisible" width="400px">
			<el-form label-width="140px" class="demo-ruleForm">
				<el-form-item label="景区语音分成比例">
					<el-input v-model="proportion">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item label="景区优惠券分成比例">
					<el-input v-model="coupon_proportion">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item label="景区明信片分成比例">
					<el-input v-model="postcard_proportion">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitDivide">保存</el-button>
					<el-button @click="divideDialogVisible = false">关闭</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 景区分成设置弹出框结束 -->
		<el-dialog v-loading="loadingImg" title="小程序码" :visible.sync="dialogQrcode" width="700px">
			<div class="wxImg">
				<img :src="wxQrCode" alt="">
				<span>请右键图片保存</span>
				<div class="wxSrc">
					<el-input ref="wxSrc" v-model="wxSrc" readonly></el-input>
					<el-button @click="copy">复制地址</el-button>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogQrcode = false">关 闭</el-button>
				<!--				<el-button type="primary" @click="downLoadImg">下 载</el-button>-->
		    </span>
		</el-dialog>
	</div>
</template>
<script>
//获取当前页面的状态并且添加事件监听
history.pushState(null, null, document.URL);
window.addEventListener("popstate", function () {
	history.pushState(null, null, document.URL);
});

import axios from "axios";
import qs from "qs";
import ElRow from "element-ui/packages/row/src/row";
import ElCol from "element-ui/packages/col/src/col";
import {mapState} from "vuex";
import api from '../../api/card';

export default {
	data() {
		return {
			loadingImg: false,
			dialogQrcode: false,
			wxQrCode: '',
			wxSrc: '',
			scenicInfo: "", //景区输入框绑定值
			areaID: "", //景区id新增、修改、删除使用
			loading: "",
			currentPage: 1,
			pageSize: 12,
			total: 0,
			scenicList: [], //景区信息存储数组
			scenicSpotList: [], //景点信息存储数组
			dolxInfo: "", //提交状态
			dialogVisibleAddScenic: false, //新增景区弹出框状态
			dialogVisible: false, //放大图片弹出框状态
			dialogImageUrl: "", //放大图片绑定值
			divideDialogVisible: false, //景区分成设置弹出框状态
			proportion: "",
			coupon_proportion: "",
			postcard_proportion: '',
			ruleForm: {
				pageView: "", //浏览量
				voicePrice: "", //语音价格
				level: 17,
				scenicMap: "", //弹出框景区地图绑定值
				grade: 0, //景区评级
				showHidden: "1", //0隐1显
				synopsis: "", //文字简介
				scenicPhoto: "", //弹出框景区图片绑定值
				fileList: [], //音频存储
				name: "",
				rightLongitude: "", //右上经度
				rightLatitude: "", //右上纬度
				leftLongitude: "", //左下经度
				leftLatitude: "", //左下纬度
				longitude: "", //景区经度
				latitude: "", //景区纬度
				area: "", //所在地区
				detailedAddress: "", //详细地址
				is_selling_tickets: '1',
				ticket_app_id: 'wx1309a456b206cda3',
				ticket_url: '',
				businessHours: "", //营业时间
				ticket: "", //门票
				playTime: "", //游玩时间
				meansOfTransportation: "", //交通方式
				tips: "", //小贴士
				recommendedRoute: [], //推荐路线
				coupon_view_flag: 1,//优惠券显示
			},
			rules: {
				voicePrice: [{
					pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
					message: "请输入正确的价格格式。",
					trigger: "blur"
				}],
				pageView: [{pattern: /^[0-9]*[1-9][0-9]*$/, message: "请输入整数", trigger: "blur"}],
				name: [{required: true, message: "请输入景区名称", trigger: "blur"}],
				area: [{required: true, message: "请输入所在地区（省市）", trigger: "blur"}],
				longitude: [{required: true, message: "请输入景点经度", trigger: "blur"}],
				latitude: [{required: true, message: "请输入景点纬度", trigger: "blur"}],
				synopsis: [{required: true, message: "请输入文字简介", trigger: "blur"}],
				//  grade:[
				//   {  required: true, }
				// ],
				// fileList:[
				//   {  required: true,}
				// ],
				//  map:[
				//   {  required: true,}
				// ],
				// scenicPhoto:[
				//   {  required: true, }
				// ]
			},
			texts: [
				" A 景区",
				" A A 景区",
				" A A A 景区",
				" A A A A 景区",
				" A A A A A 景区",
			],
		};
	},
	mounted() {
		if (this.$route.params.routerLink != undefined) {
			this.currentPage = Number(this.$route.params.routerLink);
			this.total = 10000;
		}
		this.findScenic(); //查询景区
	},
	methods: {
		//修改景点显隐状态（弹出框外开关使用）
		updateShowHidden(feng) {
			var userData = qs.parse(sessionStorage.getItem("userData"));
			var that = this;
			var salesInfoData = {
				area_id: feng.area_id, //景区id==修改/删除 ,
				area_name: feng.area_name, //景区名称 ,
				area_pic: feng.area_pic, //景区图片 ,
				area_lng: feng.area_lng, //景区坐标 经度 ,
				area_lat: feng.area_lat, //景区坐标 纬度 ,
				area_map: feng.area_map, //景区地图 ,
				area_voice: feng.area_voice, //声音介绍 ,
				area_all_lng: feng.area_all_lng, //景区左下 经度,纬度 ,
				area_all_lat: feng.area_all_lat, //景区右上 经度,纬度 ,
				area_region: feng.area_region, //景区所在地区(省市) ,
				area_address: feng.area_address, //景区详细地址 ,
				is_selling_tickets: feng.is_selling_tickets,
				ticket_url: feng.ticket_url,
				ticket_app_id: feng.ticket_app_id,
				area_worktime: feng.area_worktime, //营业时间 ,
				area_ticket: feng.area_ticket, //门票 ,
				area_playtime: feng.area_playtime, //建议游玩时间 ,
				area_traffic: feng.area_traffic, //交通 ,
				area_tips: feng.area_tips, //小贴士 ,
				area_route: feng.area_route, //推荐路线 ,
				area_leavel: feng.area_leavel, //景区级别 ,
				area_introduce: feng.area_introduce, //景区简介 ,
				order_num: feng.order_num, //景区小程序排序 ,
				area_zoom: feng.area_zoom, //景区缩放级别
				is_view: feng.is_view, //景区显示隐藏
				voice_price: feng.voice_price, //景区语音价格
				page_view: feng.page_view, //景区浏览量
			};
			var salesInfoParams = {
				methodUrl: "admin/upScenicArea",
				jsonParam: qs.stringify(salesInfoData),
			};
			this.$axios.postRequest(salesInfoParams).then(
					function (res) {
						//成功之后处理逻辑
						that.$message({
							type: "success",
							message: "设置成功",
						});
						that.findScenic();
					},
					function (res) {
						//失败之后处理逻辑
						that.$message({
							type: "error",
							message: "设置失败",
						});
						console.log("error:");
					}
			);
		},
		qrCodeDialog(row) {
			this.wxQrCode = '';
			this.wxSrc = '';
			this.loadingImg = true;
			this.dialogQrcode = true;
			api.wxQrCode({
				scene: row.area_id,
				page: 'pages/postcard/postcard',
				width: 700,
				auto_color: false,
				// line_color:'',
				is_hyaline: false,
				area_id: row.area_id,
			}).then(res => {
				this.wxQrCode = res;
				this.wxSrc = `pages/postcard/postcard?scene=${encodeURIComponent(row.area_id)}`
			}).finally(() => {
				this.loadingImg = false;
			})
		},
		copy() {
			let textarea = this.$refs.wxSrc;
			textarea.select();
			document.execCommand('Copy');
		},
		downLoadImg() {
			let a = document.createElement('a');
			a.href = this.wxQrCode;
			a.download = 'qr.png';
			// a.text = '下载文件';
			document.getElementsByTagName('body')[0].appendChild(a);
			a.click();
			this.dialogQrcode = false;
			// document.getElementsByTagName('body')[0].removeChild(a);
		},
		//查询景点
		findScenicSpot() {
			var userData = qs.parse(sessionStorage.getItem("userData"));
			var that = this;
			var salesInfoData = {
				count: true,
				area_id: that.areaID,
				orderby: "area_id desc",
				pageindex: 1,
				pagesize: 1000,
			};

			var salesInfoParams = {
				methodUrl: "admin/getScenicSpot",
				jsonParam: qs.stringify(salesInfoData),
			};
			this.$axios.postRequest(salesInfoParams).then(
					function (res) {
						//成功之后处理逻辑

						that.scenicSpotList = res.data.list;
					},
					function (res) {
						//失败之后处理逻辑
						console.log("error:");
					}
			);
		},
		//删除音频
		handleRemove(file, fileList) {
			var that = this;
			that.ruleForm.fileList = [];
		},
		handlePreview(file) {
			window.open(file.uid);
		},
		beforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${file.name}？`);
		},
		//提交音频
		submit(file) {
			this.loading = true;
			var that = this;
			let param = new FormData(); // 创建 form 对象
			param.append("file", file.file, file.file.name); // 通过 append 向 form 对象添加数据
			let config = {
				headers: {"Content-Type": "multipart/form-data"},
			}; // 添加请求头
			this.$axios.postImageRequest("admin/putObjectYy", param, config).then((response) => {
				this.ruleForm.fileList = [];
				this.ruleForm.fileList.push({
					uid: response.data,
					name: "景点语音",
				});
				that.loading = false;
			});
		},
		//景区删除
		scenicDelete(feng) {
			var that = this;
			this.$confirm("此操作将永久删除该景区,是否继续", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
				center: true,
			}).then(() => {
				var userData = qs.parse(sessionStorage.getItem("userData"));
				var deleteData = {
					area_id: feng.area_id,
				};
				var deleteParams = {
					methodUrl: "admin/delScenicArea",
					jsonParam: qs.stringify(deleteData),
				};
				this.$axios.postRequest(deleteParams).then(
						function (res) {
							//成功之后处理逻辑
							that.findScenic();
							that.$message({
								type: "success",
								message: "删除成功",
							});
						},
						function (res) {
							//失败之后处理逻辑
							console.log("error:" + res);
							that.$message({
								type: "error",
								message: "删除失败",
							});
						}
				);
			}).catch(() => {
				this.$message({
					type: "info",
					message: "已取消删除",
				});
			});
		},
		//修改景区触发
		updateScenic(feng) {
			var that = this;
			(that.ruleForm.voicePrice = feng.voice_price), //景区语音价格
					(that.ruleForm.pageView = feng.page_view), //景区浏览量
					(that.ruleForm.showHidden = feng.is_view);
			(that.ruleForm.level = parseInt(feng.area_zoom)), //景区缩放级别
					(that.ruleForm.grade = parseInt(feng.area_leavel)), //景区评级
					(that.ruleForm.synopsis = feng.area_introduce), //文字简介
					(that.ruleForm.name = feng.area_name); //景区名称
			that.ruleForm.longitude = feng.area_lng; //景区经度
			that.ruleForm.latitude = feng.area_lat; //景区纬度
			that.ruleForm.area = feng.area_region; //所在地区
			that.ruleForm.detailedAddress = feng.area_address; //详细地址
			that.ruleForm.is_selling_tickets = feng.is_selling_tickets
			that.ruleForm.ticket_url = feng.ticket_url
			that.ruleForm.ticket_app_id = feng.ticket_app_id
			that.ruleForm.businessHours = feng.area_worktime; //营业时间
			that.ruleForm.ticket = feng.area_ticket; //门票
			that.ruleForm.playTime = feng.area_playtime; //游玩时间
			that.ruleForm.meansOfTransportation = feng.area_traffic; //交通方式
			that.ruleForm.tips = feng.area_tips; //小贴士
			if (feng.area_route != "" && feng.area_route != null) {
				that.ruleForm.recommendedRoute = feng.area_route.split(","); //推荐路线
			} else {
				that.ruleForm.recommendedRoute = [];
			}
			that.ruleForm.scenicPhoto = feng.area_pic; //景区图片
			that.ruleForm.scenicMap = feng.area_map; //景区地图
			that.ruleForm.coupon_view_flag = feng.coupon_view_flag; //景区地图
			that.areaID = feng.area_id;
			that.dolxInfo = "2"; //提交状态
			that.findScenicSpot();
			that.dialogVisibleAddScenic = true;
			that.ruleForm.fileList = [];
			if (feng.area_voice != "") {
				that.ruleForm.fileList.push({
					uid: feng.area_voice,
					name: "景区音频",
				});
			}
			var left = feng.area_all_lng.split(",");
			if (left.length > 1) {
				that.ruleForm.leftLongitude = left[0];
				that.ruleForm.leftLatitude = left[1];
			}
			var right = feng.area_all_lat.split(",");
			if (right.length > 1) {
				that.ruleForm.rightLongitude = right[0];
				that.ruleForm.rightLatitude = right[1];
			}
		},
		//设置景区分成
		showDivideEditer(row) {
			this.areaID = row.area_id;
			this.proportion = row.proportion ? row.proportion : "";
			this.coupon_proportion = row.coupon_proportion ? row.coupon_proportion : "";
			this.postcard_proportion = row.postcard_proportion ? row.postcard_proportion : "";
			this.divideDialogVisible = true;
		},
		statistics(row) {
			this.$router.push({
				path: "/statistics",
				query: {id: row.area_id}
			});
		},
		submitDivide() {
			if (this.proportion && (/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(this.proportion) === false || this.proportion < 0)) {
				this.$message({
					message: "请输入正确的分成格式，最多精确到小数点后两位",
					type: "warning",
				});
				return false;
			}
			if (this.coupon_proportion && (/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(this.coupon_proportion) === false || this.coupon_proportion < 0)) {
				this.$message({
					message: "请输入正确的分成格式，最多精确到小数点后两位",
					type: "warning",
				});
				return false;
			}
			if (this.postcard_proportion && (/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(this.postcard_proportion) === false || this.postcard_proportion < 0)) {
				this.$message({
					message: "请输入正确的分成格式，最多精确到小数点后两位",
					type: "warning",
				});
				return false;
			}
			let updateData = {
				area_id: this.areaID,
				proportion: this.proportion,
				postcard_proportion: this.postcard_proportion,
				coupon_proportion: this.coupon_proportion
			};
			let updateParams = {
				methodUrl: "admin/upScenicArea",
				jsonParam: qs.stringify(updateData),
			};
			this.$axios.postRequest(updateParams).then((res) => {
						//成功之后处理逻辑
						if (res.code == 0) {
							//成功之后处理逻辑
							this.$message({
								message: "设置成功",
								type: "success",
							});
							this.divideDialogVisible = false;
							this.findScenic();
						} else {
							//输出错误信息
							this.$message({
								message: res.msg,
								type: "warning",
							});
						}
					},
					(res) => {
						//失败之后处理逻辑
						console.log("error:" + res);
						this.$message({
							type: "error",
							message: "设置失败",
						});
					}
			);
		},
		//跳转景点
		routerScenicSpot(feng) {
			var that = this;
			var idInfo = feng.area_id;
			var routerInfo = that.currentPage;
			that.$router.push({
				path: "./shopDetails",
				query: {ID: idInfo, Router: routerInfo},
			});
		},
		//新增修改景区提交
		submitAddScenic(ruleForm) {
			var userData = qs.parse(sessionStorage.getItem("userData"));
			var that = this;
			this.$refs[ruleForm].validate((valid) => {
				if (valid) {
					if (that.ruleForm.fileList.length == 0 || that.ruleForm.scenicPhoto == "") {
						if (that.ruleForm.fileList.length == 0) {
							that.$notify({
								message: "请选择音频",
								type: "warning",
								position: "top-left",
							});
						}
						setTimeout(function () {
							if (that.ruleForm.scenicPhoto == "") {
								that.$notify({
									message: "请选择景点图片",
									type: "warning",
									position: "top-left",
								});
							}
						}, 200);
					} else {
						var left = [];
						var right = [];
						var content = "";
						if (that.ruleForm.fileList.length != 0) {
							content = that.ruleForm.fileList[0].uid;
						}
						if (that.ruleForm.leftLongitude != "" && that.ruleForm.leftLatitude != "") {
							left.push(
									that.ruleForm.leftLongitude,
									that.ruleForm.leftLatitude
							);
							left = left.join(",");
						} else {
							left = left.join("");
						}
						if (that.ruleForm.rightLongitude != "" && that.ruleForm.rightLatitude != "") {
							right.push(
									that.ruleForm.rightLongitude,
									that.ruleForm.rightLatitude
							);
							right = right.join(",");
						} else {
							right = right.join("");
						}
						var salesInfoData = {
							page_view: that.ruleForm.pageView, //景区浏览量
							voice_price: that.ruleForm.voicePrice, //景区语音价格
							is_view: that.ruleForm.showHidden, //景区显隐
							area_zoom: that.ruleForm.level, //景区缩放
							area_id: that.areaID,
							area_introduce: that.ruleForm.synopsis, //文字简介
							area_leavel: that.ruleForm.grade, //景区评级
							area_name: that.ruleForm.name, // 景区名称
							area_pic: that.ruleForm.scenicPhoto, //景区图片
							area_lng: that.ruleForm.longitude, //景区坐标 经度
							area_lat: that.ruleForm.latitude, //景区坐标 纬度
							area_map: that.ruleForm.scenicMap, //景区地图
							area_voice: content, //声音介绍
							area_all_lng: left, //,景区左下 经度,纬度
							area_all_lat: right, //景区右上 经度,纬度
							area_region: that.ruleForm.area, //景区所在地区(省市)
							area_address: that.ruleForm.detailedAddress, //详细地址
							is_selling_tickets: that.ruleForm.is_selling_tickets,
							ticket_url: that.ruleForm.ticket_url,
							ticket_app_id: that.ruleForm.ticket_app_id,
							area_worktime: that.ruleForm.businessHours, // 营业时间
							area_ticket: that.ruleForm.ticket, //门票
							area_playtime: that.ruleForm.playTime, //建议游玩时间
							area_traffic: that.ruleForm.meansOfTransportation, //交通
							area_tips: that.ruleForm.tips, //小贴士
							area_route: that.ruleForm.recommendedRoute.join(","), //推荐路线
							coupon_view_flag: that.ruleForm.coupon_view_flag,
						};
						if (that.dolxInfo == "1") {
							var salesInfoParams = {
								methodUrl: "admin/addScenicArea",
								jsonParam: qs.stringify(salesInfoData),
							};
						} else if (that.dolxInfo == "2") {
							var salesInfoParams = {
								methodUrl: "admin/upScenicArea",
								jsonParam: qs.stringify(salesInfoData),
							};
						}
						this.$axios.postRequest(salesInfoParams).then(
								function (res) {
									if (res.code == 0) {
										//成功之后处理逻辑
										that.$message({
											message: "提交成功",
											type: "success",
										});
									} else {
										//输出错误信息
										that.$message({
											message: res.msg,
											type: "warning",
										});
									}

									that.dialogVisibleAddScenic = false;
									that.findScenic();
								},
								function (res) {
									//失败之后处理逻辑
									that.$message({
										message: "提交失败",
										type: "error",
									});
									console.log("error:");
								}
						).catch(error => {
							//失败之后处理逻辑
							that.$message({
								message: "提交失败",
								type: "error",
							});
							console.log(error)
						})
					}
				} else {
				}
			});
		},
		//新增修改景区弹出框关闭
		dialogVisibleAddScenicClose(ruleForm) {
			var that = this;
			that.ruleForm.level = 17;
			(that.ruleForm.synopsis = ""), //景区简介
					(that.ruleForm.grade = 0), //景区评级
					(that.ruleForm.name = ""); //景区名称
			that.ruleForm.longitude = ""; //景区经度
			that.ruleForm.latitude = ""; //景区纬度
			that.ruleForm.area = ""; //所在地区
			that.ruleForm.detailedAddress = ""; //详细地址
			that.ruleForm.is_selling_tickets = '1'
			that.ruleForm.ticket_app_id = 'wx1309a456b206cda3'
			that.ruleForm.ticket_url = ""
			that.ruleForm.businessHours = ""; //营业时间
			that.ruleForm.ticket = ""; //门票
			that.ruleForm.playTime = ""; //游玩时间
			that.ruleForm.meansOfTransportation = ""; //交通方式
			that.ruleForm.tips = ""; //小贴士
			that.ruleForm.recommendedRoute = []; //推荐路线
			that.ruleForm.scenicPhoto = ""; //景区图片
			that.ruleForm.scenicMap = ""; //景区地图
			that.ruleForm.fileList = [];
			that.ruleForm.leftLongitude = "";
			that.ruleForm.leftLatitude = "";

			that.ruleForm.rightLongitude = "";
			that.ruleForm.rightLatitude = "";
			that.dolxInfo = ""; //提交状态
			that.$refs[ruleForm].resetFields();
		},
		//上传景区图片
		submitUploadScenicPhoto(file) {
			let param = new FormData(); // 创建 form 对象
			param.append("file", file.file, file.file.name); // 通过 append 向 form 对象添加数据
			let config = {
				headers: {"Content-Type": "multipart/form-data"},
			}; // 添加请求头
			this.$axios.postImageRequest("admin/putObject", param, config).then((response) => {
				this.ruleForm.scenicPhoto = response.data;
			});
		},
		//上传景区地图
		submitUploadScenicMap(file) {
			let param = new FormData(); // 创建 form 对象
			param.append("file", file.file, file.file.name); // 通过 append 向 form 对象添加数据
			let config = {
				headers: {"Content-Type": "multipart/form-data"},
			}; // 添加请求头
			this.$axios.postImageRequest("admin/putObject", param, config).then((response) => {
				this.ruleForm.scenicMap = response.data;
			});
		},
		//查询景区
		findScenic(type) {
			var userData = qs.parse(sessionStorage.getItem("userData"));
			var that = this;
			if (type != undefined) {
				this.currentPage = type;
			}
			var salesInfoData = {
				count: true,
				area_name: that.scenicInfo,
				orderby: "a.area_id desc",
				pageindex: this.currentPage,
				pagesize: this.pageSize,
			};

			var salesInfoParams = {
				methodUrl: "admin/getScenicArea",
				jsonParam: qs.stringify(salesInfoData),
			};
			this.$axios.postRequest(salesInfoParams).then(
					function (res) {
						//成功之后处理逻辑
						document.getElementById("ceshi").scrollTop = 0;
						that.scenicList = res.data.list;

						that.total = res.data.totalcount;
					},
					function (res) {
						//失败之后处理逻辑
						console.log("error:");
					}
			);
		},
		//分页
		handleSizeChange(val) {
			this.pageSize = val;
			this.findScenic();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.findScenic();
		},
	},
};
</script>

<style>
.scroll::-webkit-scrollbar {
	display: none;
}

/*景区名称*/
.scenicName {
	line-height: 25px;
	color: #333;
	font-size: 16px;
	margin: 10px 10px 0 10px;
}

.btns {
	display: flex;
	justify-content: space-evenly;
}

.el-button--mini, .el-button--mini.is-round {
	padding: 5px 10px;
}

.wxImg {
	display: flex;
	align-items: center;
	flex-flow: column;
}

.wxImg > span {
	margin: 10px 0;
}

.wxImg > img {
	max-width: 500px;
}

.wxSrc {
	display: flex;
	align-items: center;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/storeManagementList/storeManagement.vue